"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paramKeyToParamType = exports.buyUIKeyToBuyUITypeEnum = exports.isSpuMetaKey = exports.isGroupKey = void 0;
const enums_1 = require("../enums");
function isGroupKey(key) {
    return key.startsWith(`${enums_1.BuyUITypeEnum.Group}://`);
}
exports.isGroupKey = isGroupKey;
function isSpuMetaKey(key) {
    return key.startsWith(`${enums_1.BuyUITypeEnum.SpuMeta}://`);
}
exports.isSpuMetaKey = isSpuMetaKey;
function buyUIKeyToBuyUITypeEnum(key) {
    return Object.values(enums_1.BuyUITypeEnum).find(type => key.startsWith(`${type}://`));
}
exports.buyUIKeyToBuyUITypeEnum = buyUIKeyToBuyUITypeEnum;
function paramKeyToParamType(paramKey) {
    return Object.values(enums_1.ParamTypeEnum).find(type => paramKey.startsWith(`${type}://`));
}
exports.paramKeyToParamType = paramKeyToParamType;
